import React from "react";
import PropTypes from "prop-types";

import "../switchbutton/switchbutton.css";
import clsx from "clsx";

function SwitchButton(props) {
  const { value, label, name, onChange } = props;
  const toggle = React.useRef();
  const checkbox = React.useRef();
  const [isChecked, setChecked] = React.useState(value?value:false);

  return (
    <div className="d-flex align-item-center justify-content-left switch-css">
      <span className="autolb font-weight-light"> {label} </span>
      <input
        ref={checkbox}
        name={name}
        type="checkbox"
        id={name}
        // defaultChecked={isChecked}
        value={isChecked}
        onChange={onChange}
      />
      <label
        className={clsx(value && "labelChecked")}
        htmlFor={name}
        name={name}
        ref={toggle}
        onClick={() => setChecked(!checkbox.current.checked)}
      ></label>
    </div>
  );
}

SwitchButton.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.bool,
  name: PropTypes.string,
  checked: PropTypes.bool,
};

export default SwitchButton;
